import type {MultilinkStoryblok} from '../types/storyblok';
import type {RouteLocationRaw} from 'vue-router';

export function isSbLink(link: unknown): link is MultilinkStoryblok {
  return typeof link === 'object' && Object.prototype.hasOwnProperty.call(link, 'linktype');
}

export function sbLinkUrl(link: RouteLocationRaw | MultilinkStoryblok | undefined): RouteLocationRaw | string | undefined {
  if (!isSbLink(link)) {
    return link;
  }

  switch (link.linktype) {
    case 'asset':
      return sbAssetUrl(link!.url);

    case 'email':
      return `mailto:${link.href || link.url}`;
  }

  let url = (link?.url
      || link?.cached_url
      || link?.href
      || (link.linktype === 'story' && typeof link.story === 'object' ? link.story?.full_slug : '')
      || '') as string;

  if (url.match(/^\w+:/)) {
    return url + (link.anchor ? `#${link.anchor}` : '');
  }

  const {locale} = useI18n();
  const localeRegex = new RegExp(`^/?${locale.value}/`);

  url = prefixWithSlash(url.replace(localeRegex, ''));

  const localePath = useLocalePath();
  const {isPreview} = useStoryblokPreview();

  if (isPreview.value) {
    url = `/_preview${url}`;
  }

  return localePath(url + (link.anchor ? `#${link.anchor}` : ''));
}

function prefixWithSlash(url: string) {
  return url.startsWith('/') ? url : `/${url}`;
}
